import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { uniqBy } from 'lodash';

import List from '@material-ui/core/List';

import { Field } from 'redux-form';

import OrderInformationSection from 'components/workflow/OrderInformation/OrderInformationSection';
import OrderInformationSectionTitle from 'components/workflow/OrderInformation/OrderInformationSectionTitle';
import OrderInformationSectionEmpty from 'components/workflow/OrderInformation/OrderInformationSectionEmpty';
import VitalsCreateDialog from 'components/patient/PatientProfile/Vitals/VitalsCreateDialog';

import OrderInformationVitalsMenu from './OrderInformationVitalsMenu';
import OrderInformationVitalsField from './OrderInformationVitalsField';

class OrderInformationVitals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onCreateButtonClick = this.onCreateButtonClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onMenuButtonClick(event) {
    const { Patient, fields } = this.props;
    const vitalsToAdd = fields.length > 0
      ? Patient.Vitals
        .filter(item => fields.getAll().indexOf(item.ID) === -1)
      : Patient.Vitals;
    if (vitalsToAdd.length > 0) {
      this.setState({ anchorEl: event.currentTarget });
    } else {
      this.setState({ dialogOpen: true });
    }
  }

  onCreateButtonClick() {
    this.setState({ dialogOpen: true });
  }

  onDialogClose() {
    this.setState({ dialogOpen: false });
  }

  render() {
    const { fields, Patient, Vitals, disabled } = this.props;
    const { anchorEl, dialogOpen } = this.state;
    const menuOpen = Boolean(anchorEl);
    const vitalsToAdd = fields.length > 0
      ? Patient.Vitals
        .filter(item => fields.getAll().indexOf(item.ID) === -1)
      : Patient.Vitals;
    return (
      <OrderInformationSection>
        {fields.length > 0 ? (
          <Fragment>
            <OrderInformationSectionTitle
              title="Vitals"
              addButtonOwns="order-information-add-vitals-menu"
              onAddButtonClick={this.onMenuButtonClick}
            />
            <List disablePadding>
              {fields.map((vitalsItem, index) => (
                <Field
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  name={vitalsItem}
                  component={OrderInformationVitalsField}
                  Vitals={uniqBy([
                    ...Patient.Vitals || [],
                    ...Vitals || [],
                  ], 'ID')}
                  onRemove={() => fields.remove(index)}
                />
              ))}
            </List>
          </Fragment>
        ) : (
          <OrderInformationSectionEmpty
            title="Vitals"
            text="There are no vitals"
            type="vitals"
            addButtonOwns="order-information-add-vitals-menu"
            onAddButtonClick={this.onMenuButtonClick}
            disabled={disabled}
          />
        )}
        {vitalsToAdd.length > 0 &&
          <OrderInformationVitalsMenu
            open={menuOpen}
            anchorEl={anchorEl}
            id="order-information-add-vitals-menu"
            onClose={this.onMenuClose}
            onItemClick={(item) => {
              this.onMenuClose();
              fields.push(item.ID);
            }}
            onAddButtonClick={this.onAddButtonClick}
            Vitals={vitalsToAdd}
          />
        }
        <VitalsCreateDialog
          open={dialogOpen}
          onClose={this.onDialogClose}
          onSubmitSuccess={(values) => {
            if (fields.getAll() && fields.getAll().indexOf(values.ID) === -1) {
              fields.push(values.ID);
            }
          }}
          {...{ 'Record Number': Patient['Record Number'] }}
        />
      </OrderInformationSection>
    );
  }
}

OrderInformationVitals.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string.isRequired,
    remove: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  Patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  Vitals: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
};

OrderInformationVitals.defaultProps = {
  Vitals: [],
  disabled: false,
};

export default OrderInformationVitals;



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationVitals/OrderInformationVitals.js